import { Response } from 'src/types';

import { apiRequest } from '../api';
import { endpoints } from '../config';
import { RequestMethodEnum } from '../types';
import {
  AddInteractionRequest,
  EditInteractionRequest,
  Interaction,
  InteractionDetails,
} from './types';

export const getInteractions = async (): Promise<Interaction[]> => {
  const response = await apiRequest<Response<Interaction[]>, void>(
    endpoints.interactions.getAll,
    RequestMethodEnum.GET,
    {}
  );

  return response?.data || [];
};

export const getInteraction = async (
  id: number
): Promise<InteractionDetails | undefined> => {
  const response = await apiRequest<Response<InteractionDetails>, void>(
    endpoints.interactions.getDetails(id),
    RequestMethodEnum.GET,
    {}
  );
  return response?.data;
};

export const addInteraction = async (
  data: AddInteractionRequest
): Promise<Interaction | undefined> => {
  const response = await apiRequest<
    Response<Interaction>,
    AddInteractionRequest
  >(endpoints.interactions.add, RequestMethodEnum.POST, { data });

  return response?.data;
};

export const editInteraction = async (
  id: number,
  data: EditInteractionRequest
): Promise<Interaction | undefined> => {
  const response = await apiRequest<
    Response<Interaction>,
    EditInteractionRequest
  >(endpoints.interactions.update(id), RequestMethodEnum.PATCH, {
    data,
    showSuccessMessage: true,
  });
  return response?.data;
};

export const deleteInteraction = async (
  id: number
): Promise<{ id: number } | undefined> => {
  const response = await apiRequest<Response<{ id: number }>, void>(
    endpoints.interactions.delete(id),
    RequestMethodEnum.DELETE,
    {}
  );
  return response?.data;
};
